/**
 * AI Mock Server COMPOUND_DATABASE 28종의 TypeScript 정적 데이터.
 * 원본: backend/ai_mock_server.py COMPOUND_DATABASE (42~491줄)
 */

export interface CompoundEntry {
  compound_name: string;
  compound_name_ko: string;
  cas_number: string;
  smiles: string;
  molecular_formula: string;
  compound_class: string;
  is_fire_accelerant: boolean;
  accelerant_category: string | null;
  flash_point_celsius: number;
  nfpa: { health: number; flammability: number; instability: number };
  ghs: string[];
  hazards: string[];
  precautions: string[];
  database_source: string;
}

export const COMPOUND_DATABASE: CompoundEntry[] = [
  {
    compound_name: "휘발유",
    compound_name_ko: "휘발유",
    cas_number: "8006-61-9",
    smiles: "CCCCCCCC",
    molecular_formula: "C8H18",
    compound_class: "petroleum_distillate",
    is_fire_accelerant: true,
    accelerant_category: "light_petroleum",
    flash_point_celsius: -43.0,
    nfpa: { health: 1, flammability: 3, instability: 0 },
    ghs: ["H224", "H304", "H315", "H336", "H411"],
    hazards: ["극인화성 액체 및 증기", "삼키면 기도에 침투하여 치명적일 수 있음"],
    precautions: [
      "열·스파크·화염으로부터 멀리할 것",
      "환기가 잘 되는 곳에서 사용할 것",
    ],
    database_source: "NIST_MS",
  },
  {
    compound_name: "등유",
    compound_name_ko: "등유",
    cas_number: "8008-20-6",
    smiles: "CCCCCCCCCCCC",
    molecular_formula: "C12H26",
    compound_class: "petroleum_distillate",
    is_fire_accelerant: true,
    accelerant_category: "medium_petroleum",
    flash_point_celsius: 38.0,
    nfpa: { health: 0, flammability: 2, instability: 0 },
    ghs: ["H226", "H304", "H315", "H336"],
    hazards: ["인화성 액체 및 증기", "삼키면 기도에 침투하여 치명적일 수 있음"],
    precautions: [
      "열·스파크·화염으로부터 멀리할 것",
      "용기를 밀폐하여 보관할 것",
    ],
    database_source: "NIST_MS",
  },
  {
    compound_name: "벤젠",
    compound_name_ko: "벤젠",
    cas_number: "71-43-2",
    smiles: "c1ccccc1",
    molecular_formula: "C6H6",
    compound_class: "aromatic_hydrocarbon",
    is_fire_accelerant: true,
    accelerant_category: "aromatic_solvent",
    flash_point_celsius: -11.0,
    nfpa: { health: 2, flammability: 3, instability: 0 },
    ghs: ["H225", "H304", "H315", "H319", "H340", "H350", "H372"],
    hazards: ["고인화성 액체 및 증기", "발암성 물질", "유전 독성 물질"],
    precautions: [
      "열·스파크·화염으로부터 멀리할 것",
      "보호장갑·보호의·보안경·안면보호구 착용",
    ],
    database_source: "NIST_MS",
  },
  {
    compound_name: "톨루엔",
    compound_name_ko: "톨루엔",
    cas_number: "108-88-3",
    smiles: "Cc1ccccc1",
    molecular_formula: "C7H8",
    compound_class: "aromatic_hydrocarbon",
    is_fire_accelerant: true,
    accelerant_category: "aromatic_solvent",
    flash_point_celsius: 4.0,
    nfpa: { health: 2, flammability: 3, instability: 0 },
    ghs: ["H225", "H304", "H315", "H336", "H361d", "H373"],
    hazards: ["고인화성 액체 및 증기", "생식 독성 의심 물질"],
    precautions: [
      "열·스파크·화염으로부터 멀리할 것",
      "환기가 잘 되는 곳에서 사용할 것",
    ],
    database_source: "NIST_MS",
  },
  {
    compound_name: "에탄올",
    compound_name_ko: "에탄올",
    cas_number: "64-17-5",
    smiles: "CCO",
    molecular_formula: "C2H6O",
    compound_class: "alcohol",
    is_fire_accelerant: true,
    accelerant_category: "oxygenated_solvent",
    flash_point_celsius: 13.0,
    nfpa: { health: 0, flammability: 3, instability: 0 },
    ghs: ["H225", "H319"],
    hazards: ["고인화성 액체 및 증기", "눈에 심한 자극을 일으킴"],
    precautions: ["열·스파크·화염으로부터 멀리할 것", "보안경 착용"],
    database_source: "NIST_MS",
  },
  {
    compound_name: "자일렌",
    compound_name_ko: "자일렌",
    cas_number: "1330-20-7",
    smiles: "Cc1ccccc1C",
    molecular_formula: "C8H10",
    compound_class: "aromatic_hydrocarbon",
    is_fire_accelerant: true,
    accelerant_category: "aromatic_solvent",
    flash_point_celsius: 27.0,
    nfpa: { health: 2, flammability: 3, instability: 0 },
    ghs: ["H226", "H304", "H312", "H315", "H319", "H332", "H335"],
    hazards: ["인화성 액체 및 증기", "삼키면 기도에 침투하여 치명적일 수 있음"],
    precautions: [
      "열·스파크·화염으로부터 멀리할 것",
      "환기가 잘 되는 곳에서 사용할 것",
    ],
    database_source: "NIST_MS",
  },
  {
    compound_name: "아세톤",
    compound_name_ko: "아세톤",
    cas_number: "67-64-1",
    smiles: "CC(=O)C",
    molecular_formula: "C3H6O",
    compound_class: "ketone",
    is_fire_accelerant: true,
    accelerant_category: "oxygenated_solvent",
    flash_point_celsius: -20.0,
    nfpa: { health: 1, flammability: 3, instability: 0 },
    ghs: ["H225", "H319", "H336"],
    hazards: ["고인화성 액체 및 증기", "눈에 심한 자극을 일으킴"],
    precautions: ["열·스파크·화염으로부터 멀리할 것", "보안경 착용"],
    database_source: "NIST_MS",
  },
  {
    compound_name: "헥산",
    compound_name_ko: "헥산",
    cas_number: "110-54-3",
    smiles: "CCCCCC",
    molecular_formula: "C6H14",
    compound_class: "alkane",
    is_fire_accelerant: true,
    accelerant_category: "light_petroleum",
    flash_point_celsius: -22.0,
    nfpa: { health: 1, flammability: 3, instability: 0 },
    ghs: ["H225", "H304", "H315", "H336", "H361f", "H373", "H411"],
    hazards: ["고인화성 액체 및 증기", "장기간 노출 시 신경 장애 우려"],
    precautions: [
      "열·스파크·화염으로부터 멀리할 것",
      "환기가 잘 되는 곳에서 사용할 것",
    ],
    database_source: "NIST_MS",
  },
  {
    compound_name: "Ethylbenzene",
    compound_name_ko: "에틸벤젠",
    cas_number: "100-41-4",
    smiles: "CCc1ccccc1",
    molecular_formula: "C8H10",
    compound_class: "aromatic_hydrocarbon",
    is_fire_accelerant: true,
    accelerant_category: "aromatic_solvent",
    flash_point_celsius: 15.0,
    nfpa: { health: 2, flammability: 3, instability: 0 },
    ghs: ["H225", "H304", "H332", "H373"],
    hazards: ["고인화성 액체 및 증기", "장기간 노출 시 장기 손상 우려"],
    precautions: [
      "열·스파크·화염으로부터 멀리할 것",
      "환기가 잘 되는 곳에서 사용할 것",
    ],
    database_source: "NIST_MS",
  },
  {
    compound_name: "o-Xylene",
    compound_name_ko: "오르토-자일렌",
    cas_number: "95-47-6",
    smiles: "Cc1ccccc1C",
    molecular_formula: "C8H10",
    compound_class: "aromatic_hydrocarbon",
    is_fire_accelerant: true,
    accelerant_category: "aromatic_solvent",
    flash_point_celsius: 32.0,
    nfpa: { health: 2, flammability: 3, instability: 0 },
    ghs: ["H226", "H304", "H312", "H315", "H332"],
    hazards: ["인화성 액체 및 증기", "피부와 접촉하면 유해함"],
    precautions: [
      "열·스파크·화염으로부터 멀리할 것",
      "환기가 잘 되는 곳에서 사용할 것",
    ],
    database_source: "NIST_MS",
  },
  {
    compound_name: "m-Xylene",
    compound_name_ko: "메타-자일렌",
    cas_number: "108-38-3",
    smiles: "Cc1cccc(C)c1",
    molecular_formula: "C8H10",
    compound_class: "aromatic_hydrocarbon",
    is_fire_accelerant: true,
    accelerant_category: "aromatic_solvent",
    flash_point_celsius: 27.0,
    nfpa: { health: 2, flammability: 3, instability: 0 },
    ghs: ["H226", "H304", "H312", "H315", "H332"],
    hazards: ["인화성 액체 및 증기", "피부와 접촉하면 유해함"],
    precautions: [
      "열·스파크·화염으로부터 멀리할 것",
      "환기가 잘 되는 곳에서 사용할 것",
    ],
    database_source: "NIST_MS",
  },
  {
    compound_name: "p-Xylene",
    compound_name_ko: "파라-자일렌",
    cas_number: "106-42-3",
    smiles: "Cc1ccc(C)cc1",
    molecular_formula: "C8H10",
    compound_class: "aromatic_hydrocarbon",
    is_fire_accelerant: true,
    accelerant_category: "aromatic_solvent",
    flash_point_celsius: 27.0,
    nfpa: { health: 2, flammability: 3, instability: 0 },
    ghs: ["H226", "H304", "H312", "H315", "H332"],
    hazards: ["인화성 액체 및 증기", "피부와 접촉하면 유해함"],
    precautions: [
      "열·스파크·화염으로부터 멀리할 것",
      "환기가 잘 되는 곳에서 사용할 것",
    ],
    database_source: "NIST_MS",
  },
  {
    compound_name: "Styrene",
    compound_name_ko: "스티렌",
    cas_number: "100-42-5",
    smiles: "C=Cc1ccccc1",
    molecular_formula: "C8H8",
    compound_class: "aromatic_hydrocarbon",
    is_fire_accelerant: false,
    accelerant_category: null,
    flash_point_celsius: 31.0,
    nfpa: { health: 2, flammability: 3, instability: 2 },
    ghs: ["H226", "H315", "H319", "H332", "H361d", "H372"],
    hazards: [
      "인화성 액체 및 증기",
      "흡입하면 유해함",
      "장기간 노출 시 장기 손상",
    ],
    precautions: [
      "열·스파크·화염으로부터 멀리할 것",
      "보호장갑·보안경 착용",
    ],
    database_source: "NIST_MS",
  },
  {
    compound_name: "Indene",
    compound_name_ko: "인덴",
    cas_number: "95-13-6",
    smiles: "C1=Cc2ccccc2C1",
    molecular_formula: "C9H8",
    compound_class: "aromatic_hydrocarbon",
    is_fire_accelerant: false,
    accelerant_category: null,
    flash_point_celsius: 58.0,
    nfpa: { health: 1, flammability: 2, instability: 1 },
    ghs: ["H226", "H315", "H319"],
    hazards: ["인화성 액체 및 증기", "피부에 자극을 일으킴"],
    precautions: ["열·스파크·화염으로부터 멀리할 것", "보안경 착용"],
    database_source: "NIST_MS",
  },
  {
    compound_name: "Naphthalene",
    compound_name_ko: "나프탈렌",
    cas_number: "91-20-3",
    smiles: "c1ccc2ccccc2c1",
    molecular_formula: "C10H8",
    compound_class: "pah",
    is_fire_accelerant: false,
    accelerant_category: null,
    flash_point_celsius: 79.0,
    nfpa: { health: 2, flammability: 2, instability: 0 },
    ghs: ["H302", "H351", "H410"],
    hazards: ["삼키면 유해함", "발암 의심 물질", "수생 환경에 매우 독성"],
    precautions: ["분진·흄 흡입 방지", "환경 방출 방지"],
    database_source: "NIST_MS",
  },
  {
    compound_name: "2-Methylnaphthalene",
    compound_name_ko: "2-메틸나프탈렌",
    cas_number: "91-57-6",
    smiles: "Cc1ccc2ccccc2c1",
    molecular_formula: "C11H10",
    compound_class: "pah",
    is_fire_accelerant: false,
    accelerant_category: null,
    flash_point_celsius: 97.0,
    nfpa: { health: 1, flammability: 1, instability: 0 },
    ghs: ["H302", "H410"],
    hazards: ["삼키면 유해함", "수생 환경에 매우 독성"],
    precautions: ["환경 방출 방지", "보호장갑 착용"],
    database_source: "NIST_MS",
  },
  {
    compound_name: "1-Methylnaphthalene",
    compound_name_ko: "1-메틸나프탈렌",
    cas_number: "90-12-0",
    smiles: "Cc1cccc2ccccc12",
    molecular_formula: "C11H10",
    compound_class: "pah",
    is_fire_accelerant: false,
    accelerant_category: null,
    flash_point_celsius: 82.0,
    nfpa: { health: 1, flammability: 1, instability: 0 },
    ghs: ["H302", "H410"],
    hazards: ["삼키면 유해함", "수생 환경에 매우 독성"],
    precautions: ["환경 방출 방지", "보호장갑 착용"],
    database_source: "NIST_MS",
  },
  {
    compound_name: "1,2,4-Trimethylbenzene",
    compound_name_ko: "1,2,4-트리메틸벤젠",
    cas_number: "95-63-6",
    smiles: "Cc1ccc(C)c(C)c1",
    molecular_formula: "C9H12",
    compound_class: "aromatic_hydrocarbon",
    is_fire_accelerant: true,
    accelerant_category: "aromatic_solvent",
    flash_point_celsius: 44.0,
    nfpa: { health: 2, flammability: 2, instability: 0 },
    ghs: ["H226", "H315", "H319", "H332", "H335"],
    hazards: ["인화성 액체 및 증기", "호흡기 자극을 일으킬 수 있음"],
    precautions: [
      "열·스파크·화염으로부터 멀리할 것",
      "환기가 잘 되는 곳에서 사용할 것",
    ],
    database_source: "NIST_MS",
  },
  {
    compound_name: "1,3,5-Trimethylbenzene",
    compound_name_ko: "1,3,5-트리메틸벤젠",
    cas_number: "108-67-8",
    smiles: "Cc1cc(C)cc(C)c1",
    molecular_formula: "C9H12",
    compound_class: "aromatic_hydrocarbon",
    is_fire_accelerant: true,
    accelerant_category: "aromatic_solvent",
    flash_point_celsius: 50.0,
    nfpa: { health: 2, flammability: 2, instability: 0 },
    ghs: ["H226", "H315", "H319", "H332", "H335"],
    hazards: ["인화성 액체 및 증기", "호흡기 자극을 일으킬 수 있음"],
    precautions: [
      "열·스파크·화염으로부터 멀리할 것",
      "환기가 잘 되는 곳에서 사용할 것",
    ],
    database_source: "NIST_MS",
  },
  {
    compound_name: "n-Decane",
    compound_name_ko: "데칸",
    cas_number: "124-18-5",
    smiles: "CCCCCCCCCC",
    molecular_formula: "C10H22",
    compound_class: "alkane",
    is_fire_accelerant: true,
    accelerant_category: "medium_petroleum",
    flash_point_celsius: 46.0,
    nfpa: { health: 0, flammability: 2, instability: 0 },
    ghs: ["H226", "H304", "H315", "H411"],
    hazards: ["인화성 액체 및 증기", "삼키면 기도 침투 위험"],
    precautions: ["열·스파크·화염으로부터 멀리할 것", "환경 방출 방지"],
    database_source: "NIST_MS",
  },
  {
    compound_name: "n-Dodecane",
    compound_name_ko: "도데칸",
    cas_number: "112-40-3",
    smiles: "CCCCCCCCCCCC",
    molecular_formula: "C12H26",
    compound_class: "alkane",
    is_fire_accelerant: true,
    accelerant_category: "medium_petroleum",
    flash_point_celsius: 71.0,
    nfpa: { health: 0, flammability: 2, instability: 0 },
    ghs: ["H304", "H315"],
    hazards: ["삼키면 기도에 침투하여 치명적일 수 있음"],
    precautions: ["보호장갑 착용", "환기가 잘 되는 곳에서 사용할 것"],
    database_source: "NIST_MS",
  },
  {
    compound_name: "n-Tetradecane",
    compound_name_ko: "테트라데칸",
    cas_number: "629-59-4",
    smiles: "CCCCCCCCCCCCCC",
    molecular_formula: "C14H30",
    compound_class: "alkane",
    is_fire_accelerant: true,
    accelerant_category: "medium_petroleum",
    flash_point_celsius: 99.0,
    nfpa: { health: 0, flammability: 1, instability: 0 },
    ghs: ["H304"],
    hazards: ["삼키면 기도에 침투하여 치명적일 수 있음"],
    precautions: ["보호장갑 착용"],
    database_source: "NIST_MS",
  },
  {
    compound_name: "n-Pentadecane",
    compound_name_ko: "펜타데칸",
    cas_number: "629-62-9",
    smiles: "CCCCCCCCCCCCCCC",
    molecular_formula: "C15H32",
    compound_class: "alkane",
    is_fire_accelerant: true,
    accelerant_category: "heavy_petroleum",
    flash_point_celsius: 132.0,
    nfpa: { health: 0, flammability: 1, instability: 0 },
    ghs: ["H304"],
    hazards: ["삼키면 기도에 침투하여 치명적일 수 있음"],
    precautions: ["보호장갑 착용"],
    database_source: "NIST_MS",
  },
  {
    compound_name: "Limonene",
    compound_name_ko: "리모넨",
    cas_number: "138-86-3",
    smiles: "CC(=CCC(C)C1=CC=C1)C",
    molecular_formula: "C10H16",
    compound_class: "terpene",
    is_fire_accelerant: false,
    accelerant_category: null,
    flash_point_celsius: 48.0,
    nfpa: { health: 1, flammability: 2, instability: 0 },
    ghs: ["H226", "H315", "H317", "H410"],
    hazards: ["인화성 액체 및 증기", "피부 과민성 물질"],
    precautions: ["열·스파크·화염으로부터 멀리할 것", "보호장갑 착용"],
    database_source: "NIST_MS",
  },
  {
    compound_name: "alpha-Pinene",
    compound_name_ko: "알파-피넨",
    cas_number: "80-56-8",
    smiles: "CC1=CCC2CC1C2(C)C",
    molecular_formula: "C10H16",
    compound_class: "terpene",
    is_fire_accelerant: false,
    accelerant_category: null,
    flash_point_celsius: 33.0,
    nfpa: { health: 1, flammability: 3, instability: 0 },
    ghs: ["H226", "H304", "H315", "H317", "H410"],
    hazards: ["인화성 액체 및 증기", "피부 과민성 물질"],
    precautions: ["열·스파크·화염으로부터 멀리할 것", "보호장갑 착용"],
    database_source: "NIST_MS",
  },
  {
    compound_name: "Benzaldehyde",
    compound_name_ko: "벤즈알데히드",
    cas_number: "100-52-7",
    smiles: "O=Cc1ccccc1",
    molecular_formula: "C7H6O",
    compound_class: "aldehyde",
    is_fire_accelerant: false,
    accelerant_category: null,
    flash_point_celsius: 63.0,
    nfpa: { health: 2, flammability: 2, instability: 0 },
    ghs: ["H302", "H332"],
    hazards: ["삼키면 유해함", "흡입하면 유해함"],
    precautions: ["환기가 잘 되는 곳에서 사용할 것", "보호장갑 착용"],
    database_source: "NIST_MS",
  },
  {
    compound_name: "Acetophenone",
    compound_name_ko: "아세토페논",
    cas_number: "98-86-2",
    smiles: "CC(=O)c1ccccc1",
    molecular_formula: "C8H8O",
    compound_class: "ketone",
    is_fire_accelerant: false,
    accelerant_category: null,
    flash_point_celsius: 77.0,
    nfpa: { health: 1, flammability: 2, instability: 0 },
    ghs: ["H302", "H319"],
    hazards: ["삼키면 유해함", "눈에 심한 자극을 일으킴"],
    precautions: ["보안경 착용", "보호장갑 착용"],
    database_source: "NIST_MS",
  },
  {
    compound_name: "Furfural",
    compound_name_ko: "푸르푸랄",
    cas_number: "98-01-1",
    smiles: "O=Cc1ccco1",
    molecular_formula: "C5H4O2",
    compound_class: "furan",
    is_fire_accelerant: false,
    accelerant_category: null,
    flash_point_celsius: 60.0,
    nfpa: { health: 3, flammability: 2, instability: 1 },
    ghs: ["H301", "H312", "H330", "H315", "H319", "H335"],
    hazards: [
      "삼키면 독성",
      "흡입하면 치명적",
      "피부에 자극을 일으킴",
    ],
    precautions: [
      "환기가 잘 되는 곳에서 사용할 것",
      "보호장갑·보안경·방독면 착용",
    ],
    database_source: "NIST_MS",
  },
];

/** 화합물 분류 한국어 레이블 */
export const COMPOUND_CLASS_LABELS: Record<string, string> = {
  petroleum_distillate: "석유 증류물",
  aromatic_hydrocarbon: "방향족 탄화수소",
  alcohol: "알코올",
  ketone: "케톤",
  alkane: "알칸",
  pah: "다환 방향족 탄화수소",
  terpene: "테르펜",
  aldehyde: "알데히드",
  furan: "퓨란",
};

/** 촉진제 분류 한국어 레이블 */
export const ACCELERANT_CATEGORY_LABELS: Record<string, string> = {
  light_petroleum: "경질 석유",
  medium_petroleum: "중질 석유",
  heavy_petroleum: "중질 석유",
  aromatic_solvent: "방향족 용매",
  oxygenated_solvent: "산소 함유 용매",
};
